import { render, staticRenderFns } from "./HeroComponentSlide.vue?vue&type=template&id=32a8aeed&scoped=true&"
import script from "./HeroComponentSlide.vue?vue&type=script&lang=js&"
export * from "./HeroComponentSlide.vue?vue&type=script&lang=js&"
import style0 from "./HeroComponentSlide.vue?vue&type=style&index=0&id=32a8aeed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8aeed",
  null
  
)

export default component.exports